var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosePrimary({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:#2f64f5;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10495.956-7813.582l-7,7,7-7-7-7,7,7,7-7-7,7,7,7Z",
    transform: "translate(-10485.955 7823.582)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosePrimary);
export default __webpack_public_path__ + "static/media/close-primary.deea36f3dda1b15465de9d9d1c3babcc.svg";
export { ForwardRef as ReactComponent };